import React, { useState } from 'react';
import { BaseEdge, getBezierPath } from 'reactflow';

export default function EditableEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    data,
    markerEnd,
}) {
    const [editing, setEditing] = useState(false);
    const [label, setLabel] = useState(data?.label || '');

    // Generate a smooth bezier path between source and target
    const [edgePath] = getBezierPath({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
    });

    // Handle entering edit mode
    const handleDoubleClick = () => {
        setEditing(true);
    };

    // Handle saving the label
    const handleBlur = () => {
        setEditing(false);
        if (data?.onChange) {
            data.onChange(id, label);
        }
    };

    return (
        <>
            {/* The actual edge path */}
            <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />

            {/* The label editor positioned in the middle of the edge */}
            <foreignObject
                width={150}
                height={40}
                x={(sourceX + targetX) / 2 - 75}
                y={(sourceY + targetY) / 2 - 20}
                requiredExtensions="http://www.w3.org/1999/xhtml"
                style={{ overflow: 'visible' }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'white',
                        border: '1px solid #ccc',
                        borderRadius: 4,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        padding: '0px'
                    }}
                    onDoubleClick={handleDoubleClick}
                >
                    {editing ? (
                        <input
                            value={label}
                            onChange={(e) => setLabel(e.target.value)}
                            onBlur={handleBlur}
                            autoFocus
                            style={{
                                padding: '0px',
                                width: '100%',
                                border: 'none',
                                outline: 'none',
                                background: 'transparent',
                            }}
                        />
                    ) : (
                        label || 'Double-click to edit'
                    )}
                </div>
            </foreignObject>
        </>
    );
}
